var brands = {
	"Oscar Classroom": {
		name: "OSCAR Classroom",
		defaultTheme: "accent",
		title: "OSCAR Classroom",
		hosts: ["classroom.oscarscore.com"],
		css: `
			.theme-login {
				background-color: rgb(0, 150, 136);
				color: rgba(255, 255, 255, 0.85);
			}

			.theme-login-text {
				color: rgb(0, 150, 136);
			}

			.banner {
				background-color: rgb(38, 166, 154) !important;
				box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
					0 2px 10px 0 rgba(0, 0, 0, 0.12);
				height: 300px;
				position: absolute;
				width: 100%;
			}

			.logo-mono {
				height: 150px;
				opacity: 0.4;
			}
			
			/* Midbar height + header height */
			.viewer-container {
				top: calc(56px + 64px);
			}

			.assessment-details-btn {
				height: 120px;
				width: 42.2px;
				margin-bottom: -1px;
				border-radius: 0.25rem;
			}`,
		logo: require("@/assets/images/OSCAR_Class_black.png"),
		logoHeader: require("@/assets/images/OSCAR_Class_white.png"),
		logoMono: require("@/assets/images/micss_logo_white_vert.svg")
	},
	MPS: {
		name: "MPS Classroom",
		title: "MPS Classroom",
		hosts: ["mpsclassroom.oscarscore.com", "localhost:8080"],
		css: `
			.theme-login {
				background-color: rgb(64, 64, 64);
				color: rgba(255, 255, 255, 0.85);
			}

			.theme-login-text {
				color: rgb(64, 64, 64);
			}

			.banner {
				background-color: rgb(96, 96, 96) !important;
				box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
					0 2px 10px 0 rgba(0, 0, 0, 0.12);
				height: 300px;
				position: absolute;
				width: 100%;
			}

			.logo-mono {
				height: 150px;
				opacity: 0.4;
			}
			
			/* Midbar height + header height */
			.viewer-container {
				top: calc(56px + 64px);
			}

			.assessment-details-btn {
				height: 120px;
				width: 42.2px;
				margin-bottom: -1px;
				border-radius: 0.25rem;
			}`,
		logo: require("@/assets/images/M-MPSBrgBlk.jpg"),
		logoHeader: require("@/assets/images/mps_logo1_white_oscar.png"),
		logoMono: require("@/assets/images/micss_logo_white_vert.svg")
	},
	"MI-CSS": {
		name: "MI-CSS",
		title: "MI-CSS",
		defaultTheme: "black",
		hosts: [
			"staging.mi-css.org",
			"www.mi-css.org",
			"mi-css.org",
			"localhost"
		],
		hosts: ["staging.mi-css.org", "www.mi-css.org", "mi-css.org"],
		css: `
			.theme-login {
				background-color: rgb(115, 154, 212);
				color: rgba(255, 255, 255, 0.85);
			}

			.theme-login-text {
				color: rgb(115, 154, 212);
			}

			.banner {
				background-color: rgb(143, 173, 218) !important;
				box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
					0 2px 10px 0 rgba(0, 0, 0, 0.12);
				height: 300px;
				position: absolute;
				width: 100%;
			}

			.logo-mono {
				height: 150px;
				opacity: 0.4;
			}
			
			/* Midbar height + header height */
			.viewer-container {
				top: calc(56px + 64px);
			}

			.assessment-details-btn {
				background-image: url("https://maeia-artsednetwork.org/wp-content/themes/maeia/img/logo.png");
				background-position: center; 
				background-repeat: no-repeat;
				background-size: 78px 65px;
				height: 78px;
				width: 91px;
				margin-bottom: -1px;
			}`,
		logo: require("@/assets/images/mi-css_logo2_black.png"),
		logoHeader: require("@/assets/images/mi-css_logo1_white_oscar.svg"),
		logoMono: require("@/assets/images/micss_logo_white_vert.svg"),
		externalLinkTooltip: "MAEIA Assessment Details"
	},
	"Colorado": {
		name: "OSCAR Classroom",
		defaultTheme: "black",
		title: "OSCAR Classroom",
		hosts: ["cdeclassroom.oscarscore.com","localhost:3000"],
		css: `
			.logo {
				margin-top: 30px;
				margin-bottom: 30px;
				opacity: 0.8 !important;
			}

			.theme-login {
				background-color: rgb(0, 25, 112);
				color: rgba(255, 255, 255, 0.85);
				min-height: auto;
			}
			.theme-login-light{
				background-color: rgb(51, 71, 141) !important;
				color: rgba(255, 255, 255, 0.85);
				min-height: auto;

			}
			.theme-login img {
				margin: 0;
				max-height: 3rem;
			}

			.oscar-logo img {
				margin: 0;
				max-height: 3rem;
			}

			.theme-login-text {
				color: rgb(0, 25, 112);
			}

			.banner {
				background-color: rgb(51, 71, 141) !important;
				box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
					0 2px 10px 0 rgba(0, 0, 0, 0.12);
				height: 300px;
				position: absolute;
				width: 100%;
			}

			.logo-mono {
				height: 200px;
				opacity: 0.4;
			}
			.inner-overlay {
				min-height: 500px !important;
			}
			
			/* Midbar height + header height */
			.viewer-container {
				top: calc(56px + 74px);
			}

			.assessment-details-btn {
				height: 120px;
				width: 42.2px;
				margin-bottom: -1px;
				border-radius: 0.25rem;
			}`,
		logo: require("@/assets/images/co_cde__dept_rgb_v.png"),
		logoHeader: require("@/assets/images/co_cde__dept_reverse_rgb.png"),
		logoMono: require("@/assets/images/co_cde__dept_white_v.png")
	},
	MCIEA: {
		name: "MCIEA Classroom",
		title: "MCIEA Classroom",
		hosts: ["mcieaclassroom.oscarscore.com","localhost:3000"],
		css: `
			.theme-login {
				background-color: rgb(0, 120, 142);
				color: rgba(255, 255, 255, 0.85);
			}

			.theme-login-text {
				color: rgb(64, 64, 64);
			}
			.theme-login-light {
				background-color: rgb(29, 150, 184) !important;
				color: rgba(255, 255, 255, 0.85);

			}
			.banner {
				background-color: rgb(29, 150, 184) !important;
				box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
					0 2px 10px 0 rgba(0, 0, 0, 0.12);
				height: 300px;
				position: absolute;
				width: 100%;
			}

			.logo-mono {
				height: 150px;
				opacity: 0.4;
			}
			
			/* Midbar height + header height */
			.viewer-container {
				top: calc(56px + 64px);
			}

			.assessment-details-btn {
				height: 120px;
				width: 42.2px;
				margin-bottom: -1px;
				border-radius: 0.25rem;
			}`,
		logo: require("@/assets/images/MCIEA.png"),
		logoHeader: require("@/assets/images/MCIEA.png"),
		logoMono: require("@/assets/images/MCIEA.png")
	},
};
var defaultBrand = brands["Oscar Classroom"];

export default {
	currentTheme: null,

	getHost() {
		return window.location.host;
	},

	load() {
		this.loadCSS(this.getBrand());
	},

	getBrand() {
		let host = this.getHost();
		var brand = null;
		_.each(brands, b => {
			_.each(b.hosts, h => {
				if (host == h) {
					brand = b;
				}
			});
		});

		if (brand) {
			return brand;
		} else {
			console.log("No brand found for host", host, ", using default");
			return defaultBrand;
		}
	},

	loadCSS(brand) {
		var styleElement = document.getElementById("brand-css");
		if (!styleElement) {
			var head =
				document.head || document.getElementsByTagName("head")[0];
			styleElement = document.createElement("style");
			styleElement.id = "brand-css";
			styleElement.type = "text/css";
			head.appendChild(styleElement);
		}

		var existingTextNode = styleElement.childNodes[0];
		if (existingTextNode) {
			styleElement.replaceChild(
				document.createTextNode(brand.css),
				existingTextNode
			);
		} else {
			styleElement.appendChild(document.createTextNode(brand.css));
		}
	},

	setTitle(brand) {
		console.log("Set title", brand.title);
		document.title = brand.title;
	}
};



// WEBPACK FOOTER //
// ./src/services/BrandService.js